

// Scroll Animation
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();



// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();




// Reveile Animation

function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var offset = $parent.offset();
            if (!offset) return;
            var elementTop = offset.top - $(window).scrollTop();
            if (elementTop < windowHeight - visibleOffset) {
                var $children;
                if ($parent.hasClass('slick-initialized')) {
                    $children = $parent.find('.slick-slide:not(.slick-cloned)');
                } else {
                    $children = $parent.children();
                }
                $children.each(function (index) {
                    var $ele = $(this);
                    if (!$ele.hasClass("insight")) {
                        setTimeout(function () {
                            $ele.addClass("insight");
                        }, index * delay);
                    }
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();






$(document).ready(function () {
    function checkVisibility() {
        $('.fade-in-scroll').each(function () {
            var elementTop = $(this).offset().top;
            var viewportBottom = $(window).scrollTop() + $(window).height();
            if (elementTop < viewportBottom - 1) {
                $(this).addClass('is-show');
            }
        });
    }
    checkVisibility();
    $(window).on('scroll', function () {
        checkVisibility();
    });

});




// * Header Sticky
function headerSticky() {
    const header = document.querySelector('.header');
    const targetSection = document.querySelector('.header-visible-from-here');
    if (!header || !targetSection) return;
    let triggerHeight = targetSection.offsetHeight;

    window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;
        if (currentScroll > 200) {
            header.classList.add('header__inner_pre-active');
        } else {
            header.classList.remove('header__inner_pre-active');
        }
        if (currentScroll > triggerHeight) {
            header.classList.add('header__inner_hove-active');
        } else {
            header.classList.remove('header__inner_hove-active');
        }
    });
    window.addEventListener('resize', function () {
        triggerHeight = targetSection.offsetHeight;
    });
}
window.addEventListener('load', headerSticky);





// nad-info accordion start


$(".accordion__title.active").next(".accordion__content").show();

$(".accordion__title").click(function () {

    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".accordion__content").slideUp();
    } else {
        $(".accordion__content").slideUp();
        $(".accordion__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".accordion__content").slideDown();
    }

});


// nad-info accordion end



// testimonials slider start

$('.testimonials__items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});


// testimonials slider end




// press-logos marquee start


$(".press-logos__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});

// press-logos marquee end



// wellbeing__items

$(".wellbeing__items").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});
$(".wellbeing__arrow-left").click(function () {
    $(this).parent().parent().parent().parent().parent().find(".slick-slider").slick("slickPrev");
});
$(".wellbeing__arrow-right").click(function () {
    $(this).parent().parent().parent().parent().parent().find(".slick-slider").slick("slickNext");
});



if ($(window).width() < 768) {
    $('.brand-benefits__items').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 600,
        cssEase: 'ease'
    });
}

if ($(window).width() < 768) {
    $('.featured-product__items').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}






if ($(Window).width() < 768) {
    $(".founder-note__learn-btn a").click(function (e) {
        e.preventDefault();
        var textWrap = $(".founder-note__dec");
        textWrap.toggleClass("active");
        if (textWrap.hasClass("active")) {
            $(this).text("READ LESS");
        } else {
            $(this).text("READ MORE");
        }
    });
}



(function ($) {
    function handleSlickVideos($slider) {
        if (!$slider.length) return;

        function pauseAllVideos() {
            $slider.find('video').each(function () {
                this.pause();
                this.currentTime = 0;
            });
        }

        function playActiveSlideVideo() {
            var $activeSlide = $slider.find('.slick-current');
            var $video = $activeSlide.find('video');

            pauseAllVideos();

            if ($video.length) {
                var video = $video.get(0);

                video.muted = true;
                video.setAttribute('muted', 'muted');
                video.setAttribute('playsinline', 'playsinline');
                video.setAttribute('autoplay', 'autoplay');

                var playPromise = video.play();
                if (playPromise !== undefined) {
                    playPromise.catch(function (error) {
                        console.log('Video autoplay blocked:', error);
                    });
                }
            }
        }

        $slider.on('init', function () {
            setTimeout(function () {
                playActiveSlideVideo();
            }, 200);
        });

        $slider.on('afterChange', function () {
            playActiveSlideVideo();
        });

        $slider.on('beforeChange', function () {
            pauseAllVideos();
        });

        if ($slider.hasClass('slick-initialized')) {
            playActiveSlideVideo();
        }
    }

    $(document).ready(function () {
        var $slider = $('.pro_main_photos'); // change if needed
        handleSlickVideos($slider);
    });
})(jQuery);











// announcement mobile marquee start

if ($(Window).width() < 768) {
    $(".announcement__items").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
    });
}

// announcement mobile marquee end



// single-product slider start

$('.single-product__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.single-product__small',
});
$('.single-product__small').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.single-product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1
            }
        },
    ]
});


$('.single-product__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.single-product__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// single-product slider end



// single-product live-showcase slider start


$('.single-product__live-showcase-items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
    ]
});


// single-product live-showcase slider end



$(".faq__title.active").next(".faq__content").show();

$(".faq__title").click(function () {

    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".faq__content").slideUp();
    } else {
        $(".faq__content").slideUp();
        $(".faq__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".faq__content").slideDown();
    }

});



// Start Product Description Accordion Product Page Only Mobile

$(document).ready(function () {
    $('.discription__tab-btn').click(function () {
        var tabName = $(this).attr('data-tab');

        $('.discription__tab-btn').removeClass('active');
        $(this).addClass('active');

        $('.discription__tab-item').removeClass('active');
        $('.discription__tab-item[tab-content="' + tabName + '"]').addClass('active');
    });
});

// End Product Description Accordion Product Page Only Mobile


// Start Slick SLider Product Page Team Medical Video Slider

if ($(Window).width() < 768) {
    $('.medical-team-video__items').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}
$('.medical-team-video__arrow-left').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.medical-team-video__arrow-right').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// End Slick SLider Product Page Team Medical Video Slider


// Start Medical Team Video Of / On Product Page

$(document).ready(function () {
    function formatTime(seconds) {
        if (isNaN(seconds)) return '0:00';
        var minutes = Math.floor(seconds / 60);
        var secs = Math.floor(seconds % 60);
        return minutes + ':' + (secs < 10 ? '0' : '') + secs;
    }
    function setVideoTime($item, seconds) {
        $item.find('.team-video__time p').text(formatTime(seconds));
    }
    function stopVideo($item) {
        var video = $item.find('video').get(0);
        var watchedTime = video.currentTime || 0;
        $item.data('stopped-time', watchedTime);
        setVideoTime($item, watchedTime);
        video.pause();
        video.currentTime = 0;
        video.load();
        $item.removeClass('is-playing');
        $item.find('.team-video__play').show();
    }
    $('.team-video').each(function () {
        var $item = $(this);
        var video = $item.find('video').get(0);
        $(video).on('loadedmetadata', function () {
            var stoppedTime = $item.data('stopped-time');
            if (stoppedTime || stoppedTime === 0) {
                setVideoTime($item, stoppedTime);
            } else {
                setVideoTime($item, video.duration);
            }
        });
        $(video).on('timeupdate', function () {
            if ($item.hasClass('is-playing')) {
                setVideoTime($item, video.currentTime);
            }
        });
        $(video).on('play', function () {
            $item.addClass('is-playing');
            $item.find('.team-video__play').hide();
            $item.removeData('stopped-time');
        });
        $(video).on('ended', function () {
            $item.removeClass('is-playing');
            $item.find('.team-video__play').show();
            $item.removeData('stopped-time');
            setVideoTime($item, video.duration);
            video.currentTime = 0;
            video.load();
        });
        if (video.readyState >= 1) {
            setVideoTime($item, video.duration);
        }
    });
    // $('.team-video__play').on('click', function (e) {
    //     e.stopPropagation();
    //     var $currentItem = $(this).closest('.team-video');
    //     var currentVideo = $currentItem.find('video').get(0);
    //     $('.team-video').not($currentItem).each(function () {
    //         var $item = $(this);
    //         var video = $item.find('video').get(0);
    //         if ($item.hasClass('is-playing')) {
    //             stopVideo($item);
    //         }
    //     });
    //     currentVideo.play();
    // });
    $('.team-video video').on('click', function () {
        var $currentItem = $(this).closest('.team-video');
        if ($currentItem.hasClass('is-playing')) {
            stopVideo($currentItem);
        }
    });
});

// End Medical Team Video Of / On Product Page



// Start Product Description Tab Product Page Only Desktop

$(document).ready(function () {
    $('.discription__tab-btn').on('click', function (e) {
        e.preventDefault();
        var tabName = $(this).data('tab');
        $('.discription__tab-btn').removeClass('active');
        $(this).addClass('active');
        $('.discription__tab-item').removeClass('active');
        $('.discription__tab-item').each(function () {
            if ($(this).attr('tab-content') === tabName) {
                $(this).addClass('active');
            }
        });
    });
});


// End Product Description Tab Product Page Only Desktop



function handleLoading($btn, duration = 1200) {
    const $parent = $btn.parent();

    clearTimeout($parent.data("loadingTimeout"));

    $parent.addClass("loading");

    const timeoutId = setTimeout(function () {
        $parent.removeClass("loading");
    }, duration);

    $parent.data("loadingTimeout", timeoutId);
}

$(document).on("click", ".click-loading", function (e) {
    e.preventDefault();
    handleLoading($(this));
});




if ($(Window).width() < 768) {
    $('.cart-drawer__recommended-items').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
    });
}


$(document).on("click", ".cart-drawer__accordion-title", function (e) {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".cart-drawer__accordion-content").slideUp();
    } else {
        $(".cart-drawer__accordion-content").slideUp();
        $(".cart-drawer__accordion-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".cart-drawer__accordion-content").slideDown();
    }
});



$(".header__cart").on("click", function () {
    $("body").addClass("cart-drawer-open");
    $("body").removeClass("menu-open");
})
$(".overlay").on("click", function () {
    $("body").removeClass("cart-drawer-open");
})

$(document).on("click", ".cart-drawer__close", function () {
    $("body").removeClass("cart-drawer-open");
});


// $(".cart-drawer__recommended-item-plus").on("click", function () {
//     $(this).addClass("active");
// });



// $(document).ready(function () {
//     $('.quan-plus').on('click', function () {
//         let $input = $(this).siblings('input');
//         let currentVal = parseInt($input.val());
//         if (!isNaN(currentVal)) {
//             $input.val(currentVal + 1);
//         }
//     });
//     $('.quan-minus').on('click', function () {
//         let $input = $(this).siblings('input');
//         let currentVal = parseInt($input.val());
//         if (!isNaN(currentVal) && currentVal > 1) {
//             $input.val(currentVal - 1);
//         }
//     });
// });

$(".header__menu").on("click", function () {
    $(".header__menu").toggleClass("active");
    $("body").toggleClass("menu-open");
})



function setProductOrder() {
    var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    $('.shop-products__items').each(function () {
        var $cards = $(this).children('.product-card');
        var $firstGold = $cards.filter('.product-card_poster').first();
        var order = 1;
        if (!isDesktop) {
            $cards.css('order', '');
            return;
        }
        $cards.each(function () {
            var $card = $(this);
            if ($firstGold.length && this === $firstGold[0]) return;
            if ($firstGold.length && order === 4) order = 5;
            $card.css('order', order++);
        });
        if ($firstGold.length) {
            $firstGold.css('order', 4);
        }
    });
}
$(window).on('load resize', setProductOrder);



if ($(Window).width() < 768) {
    $('.related-blog__items').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}
$('.related-blog__arrow-left').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.related-blog__arrow-right').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



gsap.registerPlugin(ScrollTrigger);

function initFooterParallax() {
    document.querySelectorAll('[data-footer-parallax]').forEach(el => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'clamp(top bottom)',
                end: 'clamp(top top)',
                scrub: true
            }
        });

        const inner = el.querySelector('[data-footer-parallax-inner]');
        const dark = el.querySelector('[data-footer-parallax-dark]');

        if (inner) {
            tl.from(inner, {
                yPercent: -25,
                ease: 'linear'
            });
        }

        if (dark) {
            tl.from(dark, {
                opacity: 0.5,
                ease: 'linear'
            }, '<');
        }
    });
}
// Initialize Footer with Parallax Effect
document.addEventListener('DOMContentLoaded', () => {
    initFooterParallax();
});




// --------------------



$(".content-toggle__title.active").next(".content-toggle__content").show();
$(".content-toggle__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).parent().removeClass("active");
        $(this).next(".content-toggle__content").slideUp();
    } else {
        $(".content-toggle__content").slideUp();
        $(".content-toggle__title").removeClass("active");
        $(".content-toggle__title").parent().removeClass("active");
        $(this).addClass("active");
        $(this).parent().addClass("active");
        $(this).next(".content-toggle__content").slideDown();
    }
});





$(document).ready(function () {
    $('.content-toggle').each(function (index) {
        var number = index + 1;
        var formattedNumber = number < 10 ? '0' + number : number;
        $(this).find('.content-toggle__title p').text(formattedNumber);
    });
});


// --------------------


$(document).on('change', '#FooterCountrySelect', function () {
  $(this).closest('form').submit();
});



$(document).ready(function () {
  $('.blog-content__share-desktop, .blog-content__share-mobile').on('click', function (e) {
    e.preventDefault();

    var url = window.location.href;
    var title = document.title;

    // Native share (mobile + supported browsers)
    if (navigator.share) {
      navigator.share({
        title: title,
        url: url
      }).catch(function (err) {
        console.log('Share cancelled', err);
      });
    } else {
      // Fallback → open share popup (Facebook as default)
      window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
        'share-window',
        'width=600,height=400'
      );
    }
  });
});



$(document).ready(function () {

  function submitContactForm($form) {
    var email = $form.find('input[name="contact[email]"]').val();

    if (!email) {
      alert('Please enter your email');
      return;
    }

    $form.submit();
  }

  $('.contact-submit-btn').on('click', function (e) {
    e.preventDefault();
    submitContactForm($(this).closest('form'));
  });

});


$('a[href*="#"]').on('click', function(event) {
  // Ensure this.hash has a value before overriding default behavior
  if (this.hash !== "") {
    event.preventDefault(); // Prevent default anchor click behavior
    var hash = this.hash;

    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 800, function(){
      // Add hash (#) to URL when done scrolling
      window.location.hash = hash;
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  var target = document.querySelector(".single-product__right");
  var stickyBar = document.querySelector(".template-product .sticky-bar");

  if (!target || !stickyBar) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Button is visible → hide sticky bar
          stickyBar.style.display = "none";
        } else {
          // Button is NOT visible → show sticky bar
          stickyBar.style.display = "block";
        }
      });
    },
    {
      root: null,
      threshold: 0 // trigger as soon as it enters/leaves viewport
    }
  );

  observer.observe(target);
});

function syncSealDescriptionsToCustomPlans() {
  $('.sls-option-container[data-selling-plan-group]').each(function () {
    var $sealPlan = $(this);

    var sellingPlanId = $sealPlan.find('.sls-select option').first().val();
    var description = $sealPlan.find('.sls-selling-plan-description-content').html();

    if (!sellingPlanId || !description) return;

    var $customInput = $('.single-product__radio-item input[name="selling_plan"][value="' + sellingPlanId + '"]');
    var $customItem = $customInput.closest('.single-product__radio-item');

    $customItem.find('.single-product__radio-content-text').html(description);
  });
}

$(document).ready(function () {
  syncSealDescriptionsToCustomPlans();

  // Seal app sometimes renders after page load
  setTimeout(syncSealDescriptionsToCustomPlans, 500);
  setTimeout(syncSealDescriptionsToCustomPlans, 1500);
});
